import { Injectable } from '@angular/core';
import { Apollo, gql } from 'apollo-angular-boost';
import * as _ from 'lodash';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { LosRoomV2Model } from '../models/los-room-v2.model';

@Injectable({
  providedIn: 'root'
})
export class LosRoomsV2Service {

  private queryList = gql`
  query roomsIds($rooms: [String!]!){
    roomsIds(rooms: $rooms){
      _id
      name
      code
      description
      active
      deletedAt
    }
  }
  `;

  constructor(
    private apollo: Apollo
  ) { }

  getRooms(rooms: String[]): Observable<LosRoomV2Model[]> {
    return this.apollo.use('public').query<any>({
      query: this.queryList,
      variables: {
        rooms: rooms
      }
    }).pipe(map(response => _.cloneDeep(response.data.roomsIds)));
  }
}
